import axios from 'axios';
import clone from 'lodash/clone';
import each from 'lodash/each';

import config from 'config';
import {PaginatableCollection} from 'domains/base/collections';

export default {
    state: {
        rules: new PaginatableCollection(),
        enums: {
            triggers: null,
            actions: null,
            attributes: null,
        },
        currentRule: false,
    },
    actions: {
        async getTriggers({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.rules_engine.list_triggers}`);

            commit('updateState', {state: state.enums, property: 'triggers', value: response.data});

            return response;
        },
        async getAttributes({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.rules_engine.list_attributes}`);

            commit('updateState', {state: state.enums, property: 'attributes', value: response.data});

            return response;
        },
        async getActions({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.rules_engine.list_actions}`);

            commit('updateState', {state: state.enums, property: 'actions', value: response.data});

            return response;
        },
        async createRule({rootState, state}) {
            let payload = clone(state.currentRule);

            payload.trigger_event_id = payload.trigger.id;

            delete payload.trigger;

            return axios.post(`${config.API_DOMAIN}${rootState.user._links.rules_engine.create}`, payload);
        },
        async updateRule({state}, rule) {
            let payload = clone(state.currentRule);

            payload.trigger_event_id = payload.trigger.id;

            delete payload.trigger;

            return axios.put(rule._links.update, payload);
        },
        async getRules({rootState, state, commit}) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.rules_engine.list_rules}?page=${rootState.route.params.page - 1}`);

            let rules = clone(response.data);

            each(rules._embedded.items, rule => {
                rule.detailsLoading = false;
                rule.details = null;
            });

            commit('setPaginatableCollection', {paginatableCollection: state.rules, data: rules});

            return response;
        },
        async removeRule({dispatch}, rule) {
            let response = await axios.delete(rule._links.delete);

            dispatch('getRules');

            return response;
        },
        async getRuleDetails({state, commit}, rule) {
            let response = await axios.get(rule._links.rule);

            commit('updateState', {state: rule, property: 'details', value: response.data});

            return response;
        },
        async getRule({rootState, state, commit}, id) {
            let response = await axios.get(`${config.API_DOMAIN}${rootState.user._links.rules_engine.get_rule.replace('{ruleId}', id)}`);

            commit('updateState', {state, property: 'currentRule', value: response.data});

            return response;
        },
    },
    mutations: {},
};
